import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
}

const IconVendors: React.FC<IconProps> = ({
  size = 15,
  className,
  ariaHidden = true,
  ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 15 14"
    fill="none"
    className={className}
    aria-hidden={ariaHidden ? true : undefined}
    aria-label={ariaLabel}
  >
    <g clipPath="url(#clip0_vendors)">
      <path d="M10.7568 0.141602C10.9435 0.159794 11.1197 0.24076 11.2559 0.37207L14.2041 3.21875L14.2617 3.28125C14.3884 3.4312 14.4589 3.6222 14.459 3.82031V5.03711C14.4588 5.40373 14.2221 5.71389 13.8936 5.82617V13.123C13.8932 13.5838 13.5194 13.9576 13.0586 13.958H1.93945C1.50718 13.9578 1.15126 13.629 1.1084 13.208L1.10449 13.123V5.8252C0.801204 5.72184 0.575385 5.45144 0.541992 5.12207L0.538086 5.03711V3.82031C0.538212 3.59387 0.630075 3.37606 0.792969 3.21875L3.74121 0.37207L3.80176 0.319336C3.94881 0.202503 4.13191 0.137766 4.32129 0.137695H10.6758L10.7568 0.141602ZM1.60449 13.123L1.61133 13.1904C1.64278 13.3429 1.77776 13.4578 1.93945 13.458H13.0586C13.2432 13.4576 13.3932 13.3077 13.3936 13.123V11.3408H1.60449V13.123ZM1.60449 10.8408H4.87207C4.99761 9.57456 6.06506 8.58513 7.36426 8.58496H7.63184C8.9312 8.58496 9.99946 9.57444 10.125 10.8408H13.3936V5.87207H1.60449V10.8408ZM7.36426 9.08496C6.34153 9.08512 5.49918 9.85137 5.37598 10.8408H9.62109C9.4979 9.85124 8.65473 9.08496 7.63184 9.08496H7.36426ZM7.62402 6.04004C8.24389 6.10309 8.72742 6.62622 8.72754 7.2627L8.72168 7.38867C8.65866 8.00865 8.13465 8.49219 7.49805 8.49219L7.37207 8.48633C6.79372 8.42731 6.33422 7.96708 6.27539 7.38867L6.26855 7.2627C6.26868 6.58384 6.81921 6.0334 7.49805 6.0332L7.62402 6.04004ZM7.49805 6.5332C7.09535 6.5334 6.76868 6.85998 6.76855 7.2627C6.76855 7.66552 7.09527 7.99199 7.49805 7.99219C7.90099 7.99219 8.22754 7.66564 8.22754 7.2627C8.22741 6.85986 7.90091 6.5332 7.49805 6.5332ZM1.03809 5.03711L1.04492 5.10449C1.07622 5.25711 1.21121 5.37188 1.37305 5.37207H13.624C13.8091 5.372 13.9588 5.22212 13.959 5.03711V4.50586H1.03809V5.03711ZM4.32129 0.637695C4.2565 0.637756 4.19334 0.656799 4.13965 0.691406L4.08887 0.731445L1.14062 3.5791C1.07532 3.64219 1.03821 3.72953 1.03809 3.82031V4.00586H13.959V3.82031C13.9589 3.75233 13.9382 3.68611 13.9004 3.63086L13.8574 3.5791L10.9092 0.731445C10.8623 0.686268 10.8032 0.655866 10.7402 0.643555L10.6758 0.637695H4.32129Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip0_vendors">
        <rect width="14" height="14" fill="currentColor" transform="translate(0.5)"/>
      </clipPath>
    </defs>
  </svg>
);

export default IconVendors;
